import React, { Component } from "react";
import Footer from "../components/Footer";
import Mainmenu from "../components/Mainmenu";
import Navbar from "../components/Navbar";

import NotificationsContent from "./NotificationsContent";

export default class Notifications extends Component {
  render() {
    let page = this.props.match.params.page;
    const urlParams = new URLSearchParams(window.location.search);
    return (
      <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <NotificationsContent id={page} urlParams={urlParams} />
        <Footer />
      </div>
    );
  }
}
